angular.module('app').directive('selectCausa', function() {
	return {
        restrict: 'E',
        template: function($element, attrs){
            var html = `
            <select class="form-control" chosen ng-options="x.id as x.nome for x in options" ng-model="ngModel" ng-change="localChange(); updateModel(ngModel);">
                <option value=""></value>
            </select>
        `;
        $jqueryElement = $(html);

            if(attrs.placeholder){
                $jqueryElement.attr('data-placeholder-text-single', "'"+attrs.placeholder+"'");
                $jqueryElement.find('option[value=""]').first().html(attrs.placeholder);
            }else{
                $jqueryElement.attr('data-placeholder-text-single', "' '");
            }

            if(attrs.required){
                $jqueryElement.attr('required', true);
            }

            return $jqueryElement[0].outerHTML;
        },
        require: 'ngModel',
        scope: {
            ngModel: '=',
            ngChange: '&',
            causa: '=?',
            ocultarPolitica: '=?'
        },
        controller: function($scope, $element, $http, $timeout, $compile) {
            $scope.options = [];

            $scope.getOptions = function(){
                var base = window.location.protocol+'//'+window.location.hostname;
                base = base.replace('politica.', '');

                $http({
                    'url': base+'/causas/select'
                }).then(function(res){
                    $scope.options = res.data.filter((item)=>{
                        if(!item.is_politica || !$scope.ocultarPolitica){
                            return item;
                        }
                    })
                });
            }

            $scope.localChange = function(){
                $scope.causa = $scope.getCausaById($scope.ngModel);
            }

            $scope.getCausaById = function(id){
                for(var i in $scope.options){
                    if($scope.options[i].id === id){
                        return $scope.options[i];
                    }
                }

                return {};
            }
            
        },
        link: function ($scope, $element, attrs, ctrl) {
            $scope.getOptions();

            $scope.updateModel = function(item) {
                ctrl.$setViewValue(item);
            }
        }
    };
})